export enum LandSystem {
    Jeffersonian = 1,
    Eastern,
    WestTexas,
    EastTexas,
}



// WEBPACK FOOTER //
// ./src/models/LandSystem.ts